




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Uploads from './Uploads.vue'
import uniqBy from 'lodash/uniqBy'
@Component({
	name: 'imageInfo',
	components: {
		Uploads,
	},
})
export default class ImageInfo extends Vue {
	@Prop()
	private data!: any
	@Prop()
	private operation!: any

	@Prop()
	private isWholeProcesDepth!: any
	@Prop()
	private isInHospital!: any

	private headerFixed = false
	private scrollElement: any = null
	private tabsList: any = [
		{
			id: '#diaocha',
			title: '调查过程环境',
			desc: '（请选择图片上传）',
			type: '7001',
			children: [],
		},
		{
			id: '#zhengju',
			title: '关键证据材料',
			desc: '（请选择图片上传）',
			type: '7002',
			children: [],
		},
		{
			id: '#bilu',
			title: '笔录',
			desc: '（请选择图片上传，非必传）',
			type: '7003',
			children: [],
		},
		{
			id: '#baogao',
			title: '调查报告',
			desc: '（请选择.pdf、.docx、.xlsx等文档上传，非必传）',
			type: 'report',
			children: [],
		},
		{
			id: '#qita',
			title: '其他',
			desc: '（请选择图片上传，非必传）',
			type: '0900',
			children: [],
		},
		{
			id: '#luyin',
			title: '录音',
			desc: '（请选择.mp3、.wav、.aac等音频上传，非必传）',
			type: 'audio',
			children: [],
			slot: 'soundRecording',
		},
		{
			id: '#shipin',
			title: '视频',
			desc: '（请选择.mp4,.m4v,.m4a,.mov等视频文件上传,非必传）',
			type: '0000',
			children: [],
			slot: 'videoList',
		},
	]
	private activeKey = 1
	private expandIconPosition = 'right'
	@Watch('operation', { immediate: true })
	private onOperationChange() {
		this.tabsList.forEach((item: any) => {
			item.children = []
		})

		let _index = 1
		let hospitalList: any = []
		this.operation.mediaInfoList &&
			this.operation.mediaInfoList.forEach((item: any) => {
				if (['h02', 'h03', 'h04', 'h05'].includes(item.type)) {
					_index =
						_index > Number(item.type.split('')[2])
							? _index
							: Number(item.type.split('')[2])
				}
			})
		hospitalList = new Array(_index).fill(1).map((_, index) => ({
			type: 'h0' + (index + 1),
			picName: '医院' + (index + 1),
			list: [],
		}))
		hospitalList = uniqBy(hospitalList, 'type')

		hospitalList &&
			hospitalList.forEach((item: any) => {
				this.operation.mediaInfoList &&
					this.operation.mediaInfoList.forEach((items: any) => {
						if (item.type === items.type) {
							item.list.push(items)
						}
					})
			})

		this.tabsList.forEach((item: any) => {
			this.operation.mediaInfoList &&
				this.operation.mediaInfoList.forEach((items: any) => {
					if (item.type === items.type) {
						item.children.push(items)
					}
					if (item.type === '7002' && this.isInHospital) {
						item.children = hospitalList
					}
				})
			this.operation.fileList &&
				this.operation.fileList.forEach((items: any) => {
					if (item.type === items.fileType) {
						items.picName = items.fileName
						items.type = items.fileType
						items.picUrl = items.fileUrl
						this.$set(items, 'playing', false)
						item.children.push(items)
					}
				})
			this.operation.videoList &&
				this.operation.videoList.forEach((items: any) => {
					if (item.type === '0000') {
						items.picName = items.orginFileName
						items.type = '0000'
						items.frameUrl = items.fileUrl
						item.children.push(items)
					}
				})
		})
	}
	private mounted() {
		window.addEventListener('scroll', this.handleScroll)
	}
	private created() {}
	private activated() {}
	private handleScroll() {
		const basicInfo: any = document.querySelector('.basicInfo')
		if (
			basicInfo &&
			window.document.documentElement.scrollTop - basicInfo.offsetHeight - 100 >
				0
		) {
			this.headerFixed = true
		} else {
			this.headerFixed = false
		}
	}

	private current = '#diaocha'
	public tabChange(item: any, index: any) {
		this.current = item.target.value

		const input: any = document.getElementById(
			item.target.value
		) as HTMLInputElement | null
		const elem = input.getBoundingClientRect()
		window.scrollTo({
			left: 0,
			top: elem.top + window.document.documentElement.scrollTop - 250,
			behavior: 'smooth',
		})
	}
	public upload(data: any) {
		this.tabsList &&
			this.tabsList.forEach((item: any) => {
				const isImg =
					['7001', '7002', '7003', '0900'].indexOf(item.type.toLowerCase()) !==
					-1
				const isVideo = ['0000'].indexOf(item.type.toLowerCase()) !== -1
				const isHospital = item.type === '7002' && this.isInHospital
				if (isVideo) {
					if (item.type === data.type) {
						item.children.push({
							orginFileName: data.orginFileName,
							yunFileName: data.yunFileName,
							picName: data.orginFileName,
							type: data.type,
							url: data.url,
						})
					}
				} else if (isHospital) {
					item.children &&
						item.children.forEach((element: any) => {
							if (element.type === data.type) {
								element.list.push({
									picUrl: data.data.accessUrl,
									picId: data.data.picId,
									fileId: data.data.fileId,
									Id: data.data.picId,
									type: data.type,
									picName: data.picName,
								})
							}
						})
				} else {
					if (item.type === data.type) {
						item.children.push({
							picUrl: data.data.accessUrl,
							picId: data.data.picId,
							fileId: data.data.fileId,
							Id: isImg ? data.data.picId : data.data.fileId,
							type: data.type,
							picName: data.picName,
						})
					}
				}
			})
		this.$emit('upload', data)
	}
	public remove(data: any) {
		this.$message.success('删除成功')
		this.$emit('remove', data)
	}
	public openImg(Img: any) {
		this.$emit('openImg', Img)
	}
}
